import axios from "axios";
import { getHeaders } from "../utils/main";
import endpoints from "./endpoints";

export const CreateStockInOutLogsApi = async data => {
  const callResponse = await axios({
    url: endpoints.updateStockLogs,
    method: "POST",
    headers: getHeaders(),

    data,
  })
    .then(response => response.data)
    .catch(err => err.response.data);

  return callResponse;
};

export const UpdateStockLocationApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.updateStockLocation,
    method: "PATCH",
    headers: getHeaders(),

    data,
  })
    .then(response => response.data)
    .catch((err) => ({ status: 0, response: err.response, code: err.response.status }));

  return callResponse;
};